import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ALL_NS } from '~/i18n/namespaces'
import { EFTypography } from '../EFTypography'
import { EFErrorDataTableProp } from './EFErrorPageContent.model'
import classNames from 'classnames/bind'
import styles from './EFErrorPageContent.module.scss'
import { ErrorPopupContent } from '../popups'

const cx = classNames.bind(styles)
export function EFErrorBox({ error }: EFErrorDataTableProp) {
  const { t } = useTranslation(ALL_NS)
  return (
    <Box className={cx('error-box-wrapper')}>
      {error ? (
        <ErrorPopupContent error={error} />
      ) : (
        <EFTypography className={cx('error-text')}>
          {t('Message_NoTableResult')}
        </EFTypography>
      )}
    </Box>
  )
}
